import type { PropsWithChildren } from 'react';

export const ContentWrapper = ({ children }: PropsWithChildren) => {
  return <span className="flex flex-col items-end xl-msq:items-start self-start">{children}</span>;
};
